import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { DevTool } from "@hookform/devtools"
import schema from "./Validation"
import { Alert, Grid, Typography } from "@mui/material"
import { AcademicLevel, Campus, ConsentementMultiple, RequiredFields, Submit } from "components"
import { Email, InputText, PhoneNumber } from "components/fields"
import { useForms, useSalesforce } from "hooks"
import { consent, consentement, defaultValues, getCampus } from "services"
import MentionsLegales from "components/MentionsLegales"
import queryString from "query-string"
import { useState } from "react"

const Form = () => {
  const { recordTypeId, salesforce, setError, setOpenSnackbar } = useForms()
  const [isFormSent, setIsFormSent] = useState(false)
    const { campaignId: campaignIdParam, utm_id, campaignid, campaign_id } = queryString.parse(document.location.search)
  // Styles
  // Form
  const methods = useForm({
    defaultValues: {
      ...consent,
      lead: {
        ...defaultValues,
        ...consentement
      }
    },
    resolver: yupResolver(schema)
  })
  const { control, reset } = methods
  // State
  // Submit form
  const onSubmit = async data => {
    setOpenSnackbar(false)
    const lead = data.lead
    const campaignId = data.campaignId
    const defaultDataLead = {
      Division__c: 'ESME',
      IONISSchool__c: 'ESME',
      LastForm__c: 'Internet : contact - simplifié',
      LeadSource: 'Internet: Demande de contact',
      RecordTypeId: recordTypeId
    }
    const finalLead = {...lead, ...defaultDataLead}

    try {
      const createdLead = await salesforce.createLead(finalLead);
      if (!createdLead) {
        throw new Error('Lead non créé');
      }
      let campaignMember = {
        CampaignId: campaignId,
        LeadId: createdLead.Id,
        Status: 'Active',
      }

      const recontactTask = {
        ActivityDate: new Date(),
        Description: "Le prospect souhaite être recontacté.",
        OwnerId: createdLead.OwnerId,
        Subject: "Recontacter le prospect",
        WhoId: createdLead.Id,
        Priority: 'High',
        Status: 'Not Started',
      };
      await salesforce.createTask(recontactTask);

      const externalId = campaignIdParam || utm_id || campaign_id || campaignid;
      if (externalId) {
        await salesforce.createCampaignMemberExternal(campaignMember, externalId)
      }
      const successUrl = new URL(window.location.href)
      successUrl.searchParams.set('sent', '1')
      window.history.replaceState({}, '', successUrl.toString())
      reset();
      setIsFormSent(true)
    } catch (error) {
      setError('Une erreur est survenue lors de la soumission du formulaire', error)
    }
  }
  // Watch
  // useEffect
  useSalesforce('EngineeringSchoolLead')

  return (
    <FormProvider {...methods}>
      <DevTool control={control} />
      {isFormSent ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Alert severity="success">
              <Typography variant="h6" gutterBottom>
                Merci pour votre intérêt.
              </Typography>
            </Alert>
          </Grid>
        </Grid>
      ) : (
      <Grid container spacing={2}>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Prénom" name="lead.FirstName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Nom" name="lead.LastName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Email control={control} label="Adresse e-mail" name="lead.Email" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <PhoneNumber control={control} name="lead.MobilePhone" label="Téléphone" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <AcademicLevel school="ESME" section={false} specialites={false} />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Campus label="Campus souhaité" options={getCampus('ESME')} />
        </Grid>
        <ConsentementMultiple callOptIn />
        <RequiredFields />
        <Submit label="Valider" onSubmit={onSubmit} />
        <MentionsLegales form="Contact" school="ESME" />
      </Grid>
      )}
    </FormProvider>
  )
}

export default Form
